//import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { SMController, SMScene } from 'react-scrollmagic';

//import Components
import Icons from '../../assets/icons/icons';


//import Style classes
import './TitleSection.css';

const logoIcon = Icons.logo;

const titleSection = (props) => {
    // console.log("[TitleSection.js]", props.data)
    let type = props.data.type ? props.data.type : "none";
    let typeClass;
    let childrenByType;
    const style = {};
    const Logo = (
        <div className="Logo">
            {logoIcon}
        </div>
    );
    if(props.backgroundColor) style.backgroundColor = props.backgroundColor;
    if(props.height) style.height = props.height;
    switch(type) {
        case "none":
            typeClass = "SpaceSection";
            break;
        case "line":
            typeClass = "LineSection";
            childrenByType = Logo;
            break;
        case "icon":
            typeClass = "IconSection";
            childrenByType = (
                <React.Fragment>
                    <div className="LeftLine"/>
                    {Logo}
                    <div className="RightLine"/>
                </React.Fragment>
            )
            break;
        default:
            // typeClass = "SpaceSection";
            break;
    }
    return (
        <SMController>
            <SMScene classToggle={["#"+props.data.id+"text", "visible"]} reverse={false}>
                <div id={props.data.id} ref={props.id} className="TitleSection" style={style}>
                    <div className={typeClass}>
                        {childrenByType}
                    </div>
                    <div id={props.data.id+"text"} className="TextSection">
                        <h3>{props.data.title[props.lang]}</h3>
                        {props.content ? <p>{props.data.content[props.lang]}</p> : null}
                    </div>
                </div>
            </SMScene>
        </SMController>
    )
}

export default titleSection;

titleSection.propTypes = {
    lang: PropTypes.string.isRequired,
    type: PropTypes.string,
    data: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string,
    height: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/TitleSection/TitleSection.js